import React, { Component, createRef } from 'react';
import { Select, message, Modal, Table, Typography, Popconfirm } from 'antd';
import LogisticsItem from './logisticsItem';
import { createMap } from '../../../../util/map';
import { getOrderPurchaseLogistics, getOrderInternalQuote, orderInternalConfirmQuote } from '../../api';
import { historyColumn, align } from './logisticsConst';
import './index.less';
import { currency } from '../../../quotationProduct/formatNumber';

const { Option } = Select;
export default class Logistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderPurchaseLogistics: [],
      currentOrderPurchaseLogistics: {},
      isModalVisible: false,
      map: undefined,
      loading: true,
      historyModalVisible: false,
      domesticLogisticsQuotation: [],
      domesticLogisticsQuotationModalVisible: false,
      internalQuoteData: {
        is_new: false,
        list: []
      }
    };
    this.aMapRef = createRef();
    this.domesticLogisticsQuotationColumns = [
      {
        title: '柜号',
        dataIndex: 'container_no',
        key: 'container_no',
        align,
      },
      {
        title: '国内物流报价(含税)',
        dataIndex: 'amount',
        key: 'amount',
        align,
        width: 200,
        render: (text, record) => {
          const { status } = record;
          return status ? currency(text || 0) : '暂无报价';
        }
      },
      {
        title: '详细说明',
        dataIndex: 'cost_desc',
        key: 'cost_desc',
        align,
      },
      {
        title: '操作',
        dataIndex: 'prod_name',
        key: 'prod_name',
        align,
        width: 200,
        render: (text, record) => {
          const { status = 0, is_confirm = 0 } = record;
          return <>
            {
              status ? <>
                {+is_confirm === 0 ? <Popconfirm title="确认报价后将不能修改" onConfirm={() => this.confirm(record)} onCancel={this.cancel} okText="确认" cancelText="取消"><Typography.Link>确认报价</Typography.Link></Popconfirm> : '已确认'}
              </> : null
            }
          </>;
        }
      },
    ];
  }
  confirm = async ({ id }) => {
    const { data: { code, msg } } = await orderInternalConfirmQuote({ id });
    if (+code === 0) {
      this.requestOrderInternalQuote();
    } else {
      message.error(msg);
    }
  }
  cancel = () => { }
  async componentDidMount() {
    const { orderNo: order_no } = this.props;
    const { data: { data, code, msg } } = await getOrderPurchaseLogistics({ order_no });
    this.AMap = await createMap();
    if (+code === 0) {
      if (data?.length) {
        const currentOrderPurchaseLogistics = data?.[0] || {};
        this.setState({ orderPurchaseLogistics: data, currentOrderPurchaseLogistics, loading: false }, this.requestOrderInternalQuote);
      }

    } else {
      message.error(msg);
    }
  }
  async requestOrderInternalQuote() {
    const { currentOrderPurchaseLogistics = {} } = this.state;
    const { batch_no } = currentOrderPurchaseLogistics;
    const { orderNo: order_no } = this.props;
    const { data: { data = { is_new: false, list: [] }, code, msg } } = await getOrderInternalQuote({ order_no, batch_no });
    if (+code === 0) {
      this.setState({ internalQuoteData: data });
    } else {
      message.error(msg);
    }
  }
  componentWillUnmount() {
    this.AMap = null;
    this.setState = () => false;
  }
  handleCancel = () => {
    this.map && this.map.destroy();
    const timer = setTimeout(() => {
      this.setState({ isModalVisible: false });
      clearTimeout(timer);
    }, 100);
  }
  drawAmap = async ({ firstGps = [], lastGps = [], type, arrive_at }) => {
    const centerPoint = (firstGps[0]?.length > 0 ? firstGps[firstGps?.length - 1] : lastGps[0]) || [116.397428, 39.90923];
    const finallyGps = firstGps.slice();
    // const strokeStyle = (+type === 1 && !arrive_at) ? 'dashed' : 'solid';
    const strokeStyle = (+type === 1) ? 'dashed' : 'solid';
    const path2 = [finallyGps[finallyGps.length - 1], ...lastGps];
    const condition = path2.filter(item => item.filter(sItem => sItem)?.length > 1)?.length > 1;
    condition && this.setState({ isModalVisible: true }, () => {
      const timer = setTimeout(() => {
        this.map = new this.AMap.Map(this.aMapRef, {
          resizeEnable: true,
          center: centerPoint,
          zoom: 5
        });
        const polyline = new this.AMap.Polyline({
          path: finallyGps,            // 设置线覆盖物路径
          strokeColor: '#3366FF',   // 线颜色
          strokeOpacity: .75,         // 线透明度
          strokeWeight: 6,          // 线宽
          strokeStyle,     // 线样式
          strokeDasharray: [10, 2, 10], // 补充线样式
          geodesic: true,            // 绘制大地线
          showDir: true,
          lineCap: 'round'
        });

        this.map.add(polyline);
        const polyline2 = new this.AMap.Polyline({
          path: path2,            // 设置线覆盖物路径
          strokeColor: '#888888',    // 线颜色
          strokeOpacity: 1,         // 线透明度
          strokeWeight: 6,          // 线宽
          strokeStyle,     // 线样式
          strokeDasharray: [0, 0, 0], // 补充线样式
          geodesic: true,            // 绘制大地线
          showDir: true,
          lineCap: 'round'
        });
        this.map.add(polyline2);
        const marker = new this.AMap.Marker({
          icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
          position: finallyGps[0],
          offset: new this.AMap.Pixel(-20, -40)
        });
        marker.setMap(this.map);
        marker.setLabel({
          direction: 'right',
          content: "<div class='info'>发货地</div>", //设置文本标注内容
        });
        const marker2 = new this.AMap.Marker({
          icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
          position: lastGps[0],
          offset: new this.AMap.Pixel(-20, -15)
        });
        marker2.setMap(this.map);
        marker2.setLabel({
          direction: 'right',
          content: "<div class='info'>收货地</div>", //设置文本标注内容
        });
        // const markerCenter = new this.AMap.Marker({
        //   icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png",
        //   position: finallyGps[finallyGps.length - 1],
        //   offset: new this.AMap.Pixel(-20, -15)
        // });
        // markerCenter.setMap(this.map);
        // markerCenter.setLabel({
        //   direction: 'right',
        //   content: "<div class='info'>当前位置</div>", //设置文本标注内容
        // });
        clearTimeout(timer);
      }, 100);
    });
  }
  handleChange = batch_no => {
    const { orderPurchaseLogistics = [] } = this.state;
    const currentOrderPurchaseLogistics = orderPurchaseLogistics.find(item => item.batch_no === batch_no);
    this.setState({ currentOrderPurchaseLogistics, batch_no }, this.requestOrderInternalQuote);
  }
  showHistory = () => {
    this.setState({ historyModalVisible: true });
  }
  handleHistoryCancel = () => {
    this.setState({ historyModalVisible: false });
  }
  openDomesticLogisticsQuotation = () => {
    this.setState({ domesticLogisticsQuotationModalVisible: true });
  }
  handleDomesticLogisticsQuotationCancel = () => {
    this.setState({ domesticLogisticsQuotationModalVisible: false });
  }
  render() {
    // const { orderPurchaseLogistics = [], currentOrderPurchaseLogistics = {}, isModalVisible = false, loading = true, historyModalVisible = false, domesticLogisticsQuotationModalVisible, internalQuoteData: { is_new = false, list: internalQuoteList = [] } } = this.state;
    const { orderPurchaseLogistics = [], currentOrderPurchaseLogistics = {}, isModalVisible = false, loading = true, historyModalVisible = false, domesticLogisticsQuotationModalVisible, internalQuoteData: { list: internalQuoteList = [] } } = this.state;
    const { batch_no, th_lists = [], zh_lists = [], old_batch_no, history_list = [] } = currentOrderPurchaseLogistics;
    const historyList = history_list.map((item, index) => ({ ...item, currentKey: index }));
    const { addressList = [], orderNo, orderInfo } = this.props;
    const baseProps = { batch_no, drawAmap: this.drawAmap, addressList, orderNo, orderInfo };
    return (
      <>
        {!loading && orderPurchaseLogistics?.length && <div className='logistics-container' >
          <div className='logistics-container-top'>
            <div className='logistics-title-container'>
              <div className='logistics-title'>物流信息</div>
              {/* {internalQuoteList ? <><Typography.Link className='search-item-tag-container' onClick={this.openDomesticLogisticsQuotation}><span>国内物流报价</span>{is_new ? <span className='search-item-tag'>new</span> : null}</Typography.Link></> : null} */}
              <div className='logistics-select'>
                <div>批次号：</div>
                <Select key={batch_no} defaultValue={batch_no} style={{ width: 120 }} onChange={this.handleChange}>{orderPurchaseLogistics.map(item => <Option key={item.batch_no} value={item.batch_no}>{item.batch_no}</Option>)}</Select>
              </div>
              {old_batch_no ? <div onClick={() => this.showHistory()}><Typography.Link>更换物流之前的批次号：{old_batch_no}</Typography.Link></div> : null}
            </div>
          </div>
          <div className='logistics-info-content'>
            {th_lists?.length ? <LogisticsItem{...{ key: 1, type: 1, currentLogistics: th_lists, ...baseProps }} /> : null}
            {zh_lists?.length ? <LogisticsItem{...{ key: 2, type: 2, currentLogistics: zh_lists, ...baseProps }} /> : null}
          </div>
          {/* 物流地图 */}
          <>
            <Modal destroyOnClose title="物流地图" width={840} open={isModalVisible} footer={null} onCancel={this.handleCancel}>
              <div id="id" ref={el => this.aMapRef = el} className="map" style={{ width: '800px', height: '400px' }}>...</div>
            </Modal>
          </>
          {/* 历史记录 */}
          <>
            <Modal
              destroyOnClose
              title="历史记录"
              width={1000}
              open={historyModalVisible}
              footer={null}
              onCancel={this.handleHistoryCancel}>
              <Table dataSource={historyList} rowKey='currentKey' columns={historyColumn} pagination={false} style={{ marginBottom: '20px' }} />
            </Modal>
          </>
          {/* 国内物流报价 */}
          <>
            <Modal
              open={domesticLogisticsQuotationModalVisible}
              destroyOnClose
              title="国内物流报价"
              width={1000}
              footer={null}
              onCancel={this.handleDomesticLogisticsQuotationCancel}>
              <Table dataSource={internalQuoteList} rowKey='prod_code' columns={this.domesticLogisticsQuotationColumns} pagination={false} style={{ marginBottom: '20px' }} />
            </Modal>
          </>
        </div>}
      </>
    );
  }
}
